import { api as axiosApi } from '../../utils/axios';

const useAdminUserExport = () => {
    const exportUsers = (): Promise<void> => {
        return axiosApi
            .get('api/v1/admin/users/export', { responseType: 'blob' })
            .then((resp) => {
                const contentDisposition = resp.headers['content-disposition'];
                let filename = 'users_export.csv';
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
                    if (match) filename = match[1];
                }
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            });
    };

    return { exportUsers };
};

export default useAdminUserExport;
